import type { FC } from "react";
import styles from "./ProgressBar.module.css";
import { useWorkflow } from "@/hooks";

interface ProgressBarProps {}

export const ProgressBar: FC<ProgressBarProps> = () => {
  const { steps, currentStep } = useWorkflow();

  const currentIndex = steps.findIndex(
    (step) => currentStep && step.id === currentStep.id,
  );
  const progress = (currentIndex / (steps.length - 1)) * 100;

  return (
    <div className={styles.container}>
      <div className={styles.progressBar}>
        <div
          className={styles.progressFill}
          style={{ width: `${progress === 0 ? 10 : progress}%` }}
        />
      </div>
    </div>
  );
};
